// 游戏常量配置

// 游戏区大小
export const BOARD_WIDTH = 10;
export const BOARD_HEIGHT = 20;
export const CELL_SIZE = 30;

// 方块颜色
export const COLORS = [
  '#0341AE', // I - 青色
  '#FFD500', // O - 黄色
  '#FF971C', // L - 橙色
  '#0073FF', // J - 蓝色
  '#72CB3B', // S - 绿色
  '#FF3213', // Z - 红色
  '#B300FF'  // T - 紫色
];

// 方块形状
export const SHAPES = [
  // I
  [
    [0, 0, 0, 0],
    [1, 1, 1, 1],
    [0, 0, 0, 0],
    [0, 0, 0, 0]
  ],
  // O
  [
    [1, 1],
    [1, 1]
  ],
  // L
  [
    [0, 0, 1],
    [1, 1, 1],
    [0, 0, 0]
  ],
  // J
  [
    [1, 0, 0],
    [1, 1, 1],
    [0, 0, 0]
  ],
  // S
  [
    [0, 1, 1],
    [1, 1, 0],
    [0, 0, 0]
  ],
  // Z
  [
    [1, 1, 0],
    [0, 1, 1],
    [0, 0, 0]
  ],
  // T
  [
    [0, 1, 0],
    [1, 1, 1],
    [0, 0, 0]
  ]
];

// 游戏级别和速度（毫秒/下落一步）
export const SPEEDS = {
  1: 800,
  2: 650, 
  3: 500,
  4: 370,
  5: 250,
  6: 160,
  7: 100,
  8: 80,
  9: 50,
  10: 30
};

// 按键代码
export const KEYS = {
  LEFT: 'ArrowLeft',
  RIGHT: 'ArrowRight',
  DOWN: 'ArrowDown',
  UP: 'ArrowUp', // 旋转
  SPACE: ' ',    // 快速下落
  P: 'p'         // 暂停
};